import { Controller } from "@hotwired/stimulus"

// Toggleable list items with circle check icons.
// Each item has a hidden checkbox and a visual icon that swaps on click.
export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    // Don't toggle if they clicked the submit button
    if (event.target.closest("button, input[type=submit], a")) return

    const item = event.currentTarget
    const checkbox = item.querySelector("input[type=checkbox]")
    if (!checkbox) return

    checkbox.checked = !checkbox.checked
    this.updateIcon(item, checkbox.checked)
  }

  updateIcon(item, checked) {
    const icon = item.querySelector("[data-icon]")
    if (!icon) return

    if (checked) {
      icon.innerHTML = '<svg class="size-7 text-primary-500" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" /></svg>'
      item.classList.add("border-primary-500/40", "bg-primary-500/5")
      item.classList.remove("border-gray-700", "bg-gray-900/30")
    } else {
      icon.innerHTML = '<svg class="size-7 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9.75" /></svg>'
      item.classList.remove("border-primary-500/40", "bg-primary-500/5")
      item.classList.add("border-gray-700", "bg-gray-900/30")
    }
  }
}
